<template>
  <div>
    <vs-card>
      <vs-row>
        <vs-col
          vs-lg="3"
          vs-md="4"
          vs-sm="6"
          vs-xs="12"
          class="d-flex align-items-center"
        >
          <vs-input
            :label="$t('Time.From')"
            timezone="FR-fr"
            :max="endDate"
            type="date"
            class="w-100 mb-4"
            v-model="startDate"
          />
        </vs-col>
        <vs-col
          vs-lg="3"
          vs-md="4"
          vs-sm="6"
          vs-xs="12"
          class="d-flex align-items-center"
        >
          <vs-input
            :label="$t('Time.To')"
            timezone="FR-fr"
            :max="new Date().toISOString().split('T')[0]"
            :min="startDate"
            type="date"
            class="w-100 mb-4"
            v-model="endDate"
          />
        </vs-col>

        <vs-col
          vs-lg="4"
          vs-md="4"
          vs-sm="6"
          vs-xs="12"
          class="d-flex align-items-center"
        >
          <vs-input
            :label="$t('Feedbacks.Filter.search')"
            :placeholder="$t('Feedbacks.Filter.searchPlaceholder')"
            type="text"
            class="w-100 mb-4"
            v-model="searchKeyword"
          />
        </vs-col>
        <!-- <vs-col vs-lg="3" vs-md="4" vs-sm="6" vs-xs="12" class="d-flex align-items-center">
                <BusinessSelectFilter :multiselect="true" v-on:selectBusiness="loadSmsByRange" style="z-index: 9999999999;"></BusinessSelectFilter>
            </vs-col> -->
        <vs-col
          vs-lg="2"
          vs-md="4"
          vs-sm="6"
          vs-xs="12"
          class="d-flex align-items-center"
        >
          <button
            class="btn btn-primary"
            style="border-radius: 5px; width: 100%"
            @click="loadSmsByRange"
          >
            Filtrer
          </button>
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-row vs-justify="center" id="customers-box">
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
      >
        <div class="title">{{ totalItems + " " + $t("SMS.smsSent") }}</div>
        <vs-card>
          <vs-table
            style="z-index: 99999999"
            :sst="true"
            @selected="handleSelected"
            :total="totalItems"
            max-items="10"
            :data="transactions"
            id="smsTable-box"
          >
            <div slot="header"></div>
            <template slot="thead">
              <vs-th sort-key="contactname">{{ $t("SMS.Table.sentBy") }}</vs-th>
              <vs-th sort-key="contactname">{{
                $t("SMS.Table.Destination")
              }}</vs-th>
              <vs-th sort-key="joindate">{{ $t("SMS.Table.Message") }}</vs-th>
              <vs-th sort-key="phone">{{ $t("SMS.Table.SentAt") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].destination">
                  <div class="align-items-center">
                    <span style="display: block">{{ data[indextr].name }}</span>
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].destination">
                  <div class="align-items-center">
                    <span style="display: block">{{
                      data[indextr].destination
                    }}</span>
                    <small v-if="data[indextr].user">{{
                      data[indextr].user.fullname
                    }}</small>
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].message">
                  <div class="d-flex align-items-center">
                    {{ data[indextr].message }}
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].created_at">
                  <div class="d-flex align-items-center">
                    <span class="text-muted">{{
                      data[indextr].created_at
                    }}</span>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination
            :total="totalPages"
            @change="handleChangePage"
            v-model="currentPage"
          ></vs-pagination>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { smsService } from "../../_services";
import router from "../../_helpers/router";
import BusinessSelectFilter from "../../components/shared/BusinessSelectFilter";
// moment

export default {
  name: "Sms",
  data: () => ({
    title: "Sms",
    transactions: [],
    selected: {},
    allowance: 0,
    consumed: 0,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    maxItems: 0,
    startDate: null,
    endDate: null,
    searchKeyword: null,
  }),
  components: {
    BusinessSelectFilter,
  },
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#smsTable-box",
        scale: 0.6,
      });
    },
    filterByBuisiness(selected) {
      this.showLoading();
      smsService
        .getByBusiness(selected.id)
        .then((data) => {
          this.transactions = data.transactions.data;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    goToNextPage() {
      router.push({ path: "/kiosks?istour=on" });
    },
    hideLoading() {
      this.$vs.loading.close("#smsTable-box > .con-vs-loading");
    },
    handleSelected() {
      /* eslint-disable */
      // console.log(this.selected);
    },
    loadSmsByRange(selected_business = null) {
      // if(this.startDate!='' && this.endDate !=''){
      this.showLoading();
      smsService
        .getByDateRange(
          this.startDate,
          this.endDate,
          this.searchKeyword,
          selected_business ? selected_business.id : null
        )
        .then((data) => {
          this.transactions = data.transactions.data;
          this.allowance = data.allowance;
          this.consumed = data.consumed;
          this.totalItems = data.transactions.total;
          this.maxItems = data.transactions.per_page;
          this.totalPages = data.transactions.last_page;
        })
        .finally(() => {
          this.hideLoading();
        });
      // }
    },
    handleSearch(keyword) {
      /*this.showLoading();
                this.searchKeyword = keyword;
                if (keyword == '') {
                    customerService.getPage(1).then(function (data) {
                        this.contacts = data.customers.data;
                        this.totalItems = data.customers.total;
                        this.totalPages = data.customers.last_page;
                        this.maxItems = data.customers.per_page;
                    }.bind(this)).finally(function () {
                        this.hideLoading();
                    }.bind(this));
                }*/
    },
    handleChangePage(page) {
      this.showLoading();
      smsService
        .getByDateRange(this.startDate, this.endDate, this.searchKeyword, null)
        .then((data) => {
          this.transactions = data.transactions.data;
          this.allowance = data.allowance;
          this.consumed = data.consumed;
          this.totalItems = data.transactions.total;
          this.maxItems = data.transactions.per_page;
          this.totalPages = data.transactions.last_page;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    handleSort(key, active) {
      /* eslint-disable */
      // console.log({ key, active });
    },
    formatDate: function (value) {
      let date = this.$moment(value).fromNow();
      return date;
    },
  },
  mounted() {
    // this.showLoading();
    // smsService
    //   .getByDateRange(this.startDate, this.endDate, this.searchKeyword, null)
    //   .then((data) => {
    //     this.transactions = data.transactions.data;
    //     this.allowance = data.allowance;
    //     this.consumed = data.consumed;
    //     this.totalItems = data.transactions.total;
    //     this.maxItems = data.transactions.per_page;
    //     this.totalPages = data.transactions.last_page;
    //     console.log(this.transactions);
    //   })
    //   .finally(() => {
    //     this.hideLoading();
    //   });
  },
};
</script>

<style scoped>
.title {
  font-size: 20px;
  letter-spacing: 2px;
  margin-bottom: 15px;
}
</style>